var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToTheMoon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 162 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "To The Moon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nights_stay",
    d: "M132.013 34H127.64L128.481 33.4688C129.042 33.1146 129.652 32.7179 130.31 32.2788C130.969 31.8396 131.579 31.4429 132.139 31.0888L132.98 30.5575C135.251 30.3875 137.346 29.6933 139.266 28.475C141.186 27.2567 142.707 25.6275 143.828 23.5875C141.417 23.3608 139.133 22.7446 136.974 21.7388C134.816 20.7329 132.882 19.3658 131.172 17.6375C129.462 15.9092 128.103 13.9542 127.094 11.7725C126.085 9.59083 125.482 7.28167 125.286 4.845C123.127 6.06333 121.439 7.74208 120.219 9.88125C119 12.0204 118.39 14.3367 118.39 16.83V17.34L117.886 17.5738C117.549 17.7296 117.178 17.8925 116.772 18.0625C116.365 18.2325 115.994 18.3954 115.657 18.5513L115.153 18.785C115.097 18.4733 115.062 18.1475 115.048 17.8075C115.034 17.4675 115.027 17.1417 115.027 16.83C115.027 12.6933 116.33 9.04542 118.937 5.88625C121.544 2.72708 124.865 0.765 128.902 0C128.397 2.805 128.551 5.54625 129.364 8.22375C130.177 10.9013 131.579 13.2458 133.569 15.2575C135.559 17.2692 137.878 18.6858 140.527 19.5075C143.176 20.3292 145.888 20.485 148.663 19.975C147.934 24.055 146 27.4125 142.861 30.0475C139.721 32.6825 136.106 34 132.013 34ZM120.072 30.6H127.64C128.341 30.6 128.937 30.3521 129.427 29.8563C129.918 29.3604 130.163 28.7583 130.163 28.05C130.163 27.3417 129.925 26.7396 129.448 26.2438C128.972 25.7479 128.397 25.5 127.724 25.5H125.538L124.697 23.46C124.305 22.525 123.688 21.7813 122.847 21.2288C122.006 20.6763 121.081 20.4 120.072 20.4C118.671 20.4 117.479 20.8888 116.498 21.8663C115.517 22.8438 115.027 24.055 115.027 25.5C115.027 26.9167 115.517 28.1208 116.498 29.1125C117.479 30.1042 118.671 30.6 120.072 30.6ZM120.072 34C117.746 34 115.763 33.1713 114.123 31.5138C112.483 29.8563 111.663 27.8517 111.663 25.5C111.663 23.1483 112.483 21.1438 114.123 19.4863C115.763 17.8288 117.746 17 120.072 17C121.754 17 123.289 17.4604 124.676 18.3813C126.064 19.3021 127.094 20.5417 127.766 22.1C129.364 22.1567 130.724 22.7588 131.845 23.9062C132.966 25.0538 133.527 26.435 133.527 28.05C133.527 29.6933 132.952 31.0958 131.803 32.2575C130.654 33.4192 129.266 34 127.64 34H120.072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M156.663 152H4.66309L0.663086 147.787C1.86309 123.072 22.8298 122.823 33.1631 125.787C40.3631 111.932 57.1631 115.333 64.6631 118.766C65.8631 118.766 66.8298 111.589 67.1631 108H95.1631C94.7631 115.864 97.6631 118.454 99.1631 118.766C113.563 110.902 125.83 120.17 130.163 125.787C152.163 120.17 160.33 138.738 161.663 148.723L156.663 152Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6633 107.15H62.6633C64.2633 108.35 64.9966 113.984 65.1633 116.65H96.6633C95.4633 114.65 97.4966 109.484 98.6633 107.15Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.663 59.6503H61.1633C57.9633 75.6503 59.83 91.9837 61.1633 98.1503H101.663C104.063 85.3503 101.997 67.1503 100.663 59.6503Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1633 109.65L43.1633 116.65C32.7633 111.05 42.1633 88.6503 48.1633 78.1503C44.9633 86.1503 49.4966 102.484 52.1633 109.65Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6633 50.1503H65.1633C63.5633 42.5503 71.83 33.9837 76.1633 30.6503V14.6503C80.5633 9.85033 84.33 12.6503 85.6633 14.6503V30.6503C93.6633 35.4503 96.33 45.6503 96.6633 50.1503Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.663 116.65L108.163 109.65C111.363 111.65 113.83 88.4837 114.663 76.6504C125.863 104.65 121.33 114.984 117.663 116.65Z",
    fill: "#135FC2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1910",
    cx: 80.6631,
    cy: 79,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1911",
    cx: 80.6631,
    cy: 79,
    r: 5,
    fill: "#135FC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTheMoon);
export default __webpack_public_path__ + "static/media/ToTheMoon.54722b1eddffd57a4f0463835fcc9f06.svg";
export { ForwardRef as ReactComponent };